function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m0 54.771v402.459h71.373l14.135-28.976h340.985l14.135 28.976h71.372v-402.459zm66.762 343.482-14.135 28.976h-22.627v-342.458h326v30h-296v253.483h296v30h-289.238zm289.238-119.741h-29.5v-74h29.5zm0-104h-59.5v134h59.5v29.741h-266v-193.482h266zm126 252.717h-22.627l-14.135-28.976h-59.238v-313.482h96z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.667 131.528h30v29.969h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.667 194.861h30v29.969h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.667 258.194h30v29.969h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.667 321.528h30v29.969h-30z"
}));

function Svg74(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg74);
export default __webpack_public_path__ + "static/media/7_4.329fb175.svg";
export { ForwardRef as ReactComponent };